import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { deleteComptable, getComptable } from './comptable-reducer';
export const ComptableModal = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const comptable = useAppSelector(state => state.comptable.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const showModal = () => {
    setIsModalVisible(true);
  };
  useEffect(() => {
    dispatch(getComptable(props.match.params.id));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/comptable/${currentEcole && currentEcole.id}`);
  };

  const confirmDelete = event => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      id: props.match.params.id,
    };
    dispatch(deleteComptable(entity));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <Modal
      title="Confirmation de suppression"
      centered
      footer={[
        <Button key="back" onClick={goBack}>
          Annuler
        </Button>,
        <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmDelete}>
          Supprimer
        </Button>,
      ]}
      visible={true}
      closable={false}
    >
      Etes-vous certain de vouloir supprimer le comptable {comptable.firstName + ' ' + comptable.lastName} ?
    </Modal>
  );
};

export default ComptableModal;
